/* Keeps the Klarna / Clearpay instalment amounts in step with what the customer is actually buying:
   product page = selected bundle tier (or variant price) x quantity; cart page and cart drawer = cart total. */
(function () {
  'use strict';
  if (window.__skBnplLoaded) return;
  window.__skBnplLoaded = true;
  function pence(t) {
    var m = String(t || '').match(/\d[\d,]*\.?\d*/);
    if (!m) return 0;
    var n = parseFloat(m[0].replace(/,/g, ''));
    return isNaN(n) ? 0 : Math.round(n * 100);
  }
  function gbp(p) {
    return '£' + (p / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function paint(el, amount) {
    el.setAttribute('data-amount', amount);
    var min = parseInt(el.getAttribute('data-min'), 10) || 0;
    var max = parseInt(el.getAttribute('data-max'), 10) || Infinity;
    var ok = amount >= min && amount <= max;
    el.hidden = !ok;
    if (!ok) return;
    var k = el.querySelector('[data-bnpl-k]');
    var c = el.querySelector('[data-bnpl-c]');
    if (k) k.textContent = gbp(Math.round(amount / 3));
    if (c) c.textContent = gbp(Math.round(amount / 4));
  }
  function initPdp(el) {
    var priceEl = document.querySelector('[data-skp-price]');
    var qty = document.querySelector('#skp-form input[name="quantity"]');
    if (!priceEl) return;
    var last = -1;
    function unitPrice() {
      /* Bundle app tier: its selected bar shows the per-unit price for that tier. */
      var bars = document.querySelectorAll('kaching-bundle .kaching-bundles__bar');
      for (var i = 0; i < bars.length; i++) {
        var inp = bars[i].querySelector('input');
        if (inp && inp.checked) {
          var p = bars[i].querySelector('.kaching-bundles__bar-price');
          var v = p ? pence(p.textContent) : 0;
          if (v > 0) return v;
        }
      }
      return pence(priceEl.textContent);
    }
    function run() {
      var q = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
      var a = unitPrice() * q;
      if (a !== last) { last = a; paint(el, a); }
    }
    /* The bundle app and the +/- buttons change values without firing events, so check lightly. */
    setInterval(run, 400);
    run();
  }
  function initCart(el) {
    var last = -1;
    function run() {
      var t = document.querySelector('.info-total .item.total');
      if (!t) return;
      var a = pence(t.textContent);
      if (a !== last) { last = a; paint(el, a); }
    }
    setInterval(run, 800);
    run();
  }
  /* Cart drawer: its contents are swapped in and out, so look for the strip each tick and follow the drawer's own total. */
  function watchDrawer() {
    setInterval(function () {
      var els = document.querySelectorAll('[data-bnpl="drawer"]');
      for (var i = 0; i < els.length; i++) {
        var box = els[i].closest('.box-bottom-btn') || document;
        var t = box.querySelector('.js-total-price');
        if (!t) continue;
        var a = pence(t.textContent);
        if (els[i].getAttribute('data-amount') !== String(a)) paint(els[i], a);
      }
    }, 600);
  }
  function init() {
    document.querySelectorAll('[data-bnpl]').forEach(function (el) {
      var ctx = el.getAttribute('data-bnpl');
      if (ctx === 'pdp') initPdp(el);
      else if (ctx === 'cart') initCart(el);
    });
    watchDrawer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
